import React from "react";
import _ from "lodash";

export function checkIfHasData(model) {
  return _.get(model.docs, "length") > 0;
}

export default function DocumentsTile({ model, title, formatDate }) {
  let hasData = checkIfHasData(model);
  return (
    <React.Fragment>
      <div className="title">
        {title}
        <span className="count">{model.count > 10 ? model.count : null}</span>
      </div>
      <div className="tile-content documents">
        {!hasData && <div className="no-results">No Documents</div>}
        {hasData &&
          _.get(model, "docs", []).map((doc, i) => (
            <div className="doc" key={i}>
              <div className="name">{doc.name}</div>
              <div className="date">{formatDate(doc.date)}</div>
            </div>
          ))}
      </div>
    </React.Fragment>
  );
}
